import { render } from "./DefinirRegrasUnidade.vue?vue&type=template&id=777ff127&scoped=true"
import script from "./DefinirRegrasUnidade.vue?vue&type=script&lang=js"
export * from "./DefinirRegrasUnidade.vue?vue&type=script&lang=js"

import "./DefinirRegrasUnidade.vue?vue&type=style&index=0&id=777ff127&lang=sass"
import "./DefinirRegrasUnidade.vue?vue&type=style&index=1&id=777ff127&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777ff127"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QTable,QInput,QSelect,QBtn});
